import './RecurrenceSettings.css';

/**
 * 라벨 줄 오른쪽의 «n/한도» (2026-10-13 이식 — 옛 가지 c59fee059·f5bfc649e·c8a7df61f).
 *
 * ⭐ 한도는 입력칸의 `maxLength` 와 «같은 수»여야 한다 — 그래서 상수를 이 파일에서 함께 낸다
 *   (제목 200 = 사용자 결정 2026-10-13 · 장소 200 · 설명 5000 = 서버 스키마 `createBodySchema`).
 * ⭐ 한도에 닿으면 색으로 알린다. 넘기기 전에 입력이 멈추므로(maxLength) 저장 때 실패로 알리지 않는다.
 * ⚠ 라벨 «줄»에 얹는다 — 입력 아래에 두면 줄이 하나 늘어 칸 사이가 벌어진다(옛 가지 c8a7df61f 의 지적).
 * ⚠ `aria-live` 를 안 쓴다 — 한 글자마다 읽어 주면 시끄럽다. 대신 칸과 `aria-describedby` 로 잇는다.
 */
export const TITLE_MAX = 200;
export const LOCATION_MAX = 200;
export const DESCRIPTION_MAX = 5000;

export function LengthCounter({ id, length, max }: { id?: string; length: number; max: number }) {
  return (
    <span id={id} className={`cal-limit${length >= max ? ' cal-limit--full' : ''}`}>
      {length.toLocaleString()}/{max.toLocaleString()}
    </span>
  );
}
